import { ModulesMap, ModulesConfigMap } from "../data/modulesMaps";

export default {
  getReportsFinanceByMaterialsCategories: {
    apiServiceMethodName:
      ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_MATERIALS_CATEGORIES].GET_REPORTS_FINANCE_BY_MATERIALS_CATEGORIES
  }
}